export default function defaultState() {
  return {
    mainTitle: '',
    isSidebarShown: false,
    recordPreviewRecordModalConfig: {
      isShow: false,
      recordId: null,
    },
  }
}
